var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("ValidationProvider", {
    ref: "currencyValidator",
    attrs: {
      rules: _vm.validationRules,
      name: _vm.validatorName,
      vid: _vm.validatorName,
      immediate: "",
      tag: "div",
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function ({ errors }) {
          return [
            _c(
              "div",
              {
                class: [
                  { "error-styles": errors[0] },
                  { "disabled-field": _vm.disabled },
                  "lf-currency-container",
                ],
              },
              [
                _c("div", { staticClass: "label-container" }, [
                  _c(
                    "span",
                    {
                      class: [
                        { "required-field": _vm.requiredField },
                        "label-text",
                      ],
                    },
                    [_vm._v(_vm._s(_vm.label))]
                  ),
                  _vm.showInfo
                    ? _c("span", { class: [_vm.icons.info, "label-icon"] })
                    : _vm._e(),
                ]),
                _c("ejs-numerictextbox", {
                  ref: "numericTextBox",
                  class: [{ "error-styles": errors[0] }, "lf-currency-input"],
                  attrs: {
                    id: _vm.id,
                    name: _vm.name,
                    showSpinButton: false,
                    showClearButton: true,
                    placeholder: _vm.placeholder,
                    decimals: _vm.decimals,
                    min: _vm.minValue,
                    max: _vm.maxValue,
                    format: _vm.numberOfDecimalPlaces,
                    validateDecimalOnType: true,
                    change: _vm.onChange,
                    created: _vm.onTextBoxCreated,
                    destroyed: _vm.onTextBoxDestroyed,
                  },
                  model: {
                    value: _vm.innerValue,
                    callback: function ($$v) {
                      _vm.innerValue = $$v
                    },
                    expression: "innerValue",
                  },
                }),
                _c("div", { staticClass: "messages-container" }, [
                  errors.length
                    ? _c("span", { staticClass: "alert-message" }, [
                        _vm._v(_vm._s(errors[0])),
                      ])
                    : _c("span", { staticClass: "help-message" }, [
                        _vm._v(_vm._s(_vm.helpText)),
                      ]),
                ]),
              ],
              1
            ),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }